export default __webpack_public_path__ + "static/media/page-visited-old.f81bbff5.svg";